import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { AdminService } from '../../../admin.service';
import { Menu } from '../../../../models/menu.model';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { QuickDesign } from '../../../../models/quick-design.model';
import { QuickDesignService } from '../../../../services/quick-deisgn.service';
import { Element } from '../../../../models/element.model';
import { ElementService } from '../../../../services/element.service';
import { Subscription } from 'rxjs/Subscription';
import { MasterService } from '../../../../services/master.service';
import { StyleService } from '../../../../services/style.service';
import { Style } from '../../../../models/style.model';

import { APP_CONFIG } from '../../../../app.config';
import { Http } from '@angular/http';

import * as juice from 'juice';
import { ImageLibraryService } from '../../../../shared/imagelibrary.service';

declare var $: any;
declare var grapesjs: any;
declare var swal: any;

@Component({
  selector: 'app-quick-design-build',
  templateUrl: './quick-design-build.component.html',
  styleUrls: ['./quick-design-build.component.css']
})

export class QuickDesignBuildComponent implements OnInit, OnDestroy {
  loading = false;
  subLoading = false;
  menus: Menu[] = [];
  id: number;
  category: string;
  quickDesign: QuickDesign;
  elements: Element[] = [];
  style: Style;

  editor: any;

  enable_zoom = false;

  plugins = [];

  subscription: Subscription;
  subscriptionElement: Subscription;
  subscriptionStyle: Subscription;
  subscriptionBuild: Subscription;

  selectedFileHolder: any;
  selectedFile = [];

  @ViewChild('builderHtml') builder: ElementRef;
  @ViewChild('mdLibrarySearchModal') mdLibrarySearchModal: ElementRef;
  @ViewChild('mdLibrarySearchModalClose') mdLibrarySearchModalClose: ElementRef;

  constructor(private adminService: AdminService,
              private quickDesignService: QuickDesignService,
              private elementService: ElementService,
              private styleService: StyleService,
              private route: ActivatedRoute,
              private imagelibraryService: ImageLibraryService,
              private router: Router,
              private http: Http) { }

  ngOnInit() {
    this.loading = true;
    this.adminService.fullPageContent = true;
    this.adminService.loadMenu(this.menus);

    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.category = params['type'];

        this.quickDesignService.httpGetQuickDesign(this.id);
      }
    );

    this.plugins = ['gjs-plugin-ckeditor', 'gjs-aviary'];

    this.imagelibraryService.is_builder = true;

    this.subscription = this.quickDesignService.quickDesignChanged.subscribe(
      (quickDesign: QuickDesign) => {
        this.quickDesign = quickDesign;

        if ( this.quickDesign ) {
          this.elementService.httpGetElements(
            {
              category_id: this.quickDesign.category_id,
              group_id: this.quickDesign.group_id,
              media_attribute_id: this.quickDesign.media_attribute_id,
              department_id: this.quickDesign.department_id
            }
          );
        }
      }
    );

    this.subscriptionElement = this.elementService.elementsChanged.subscribe(
      (elements: Element[]) => {
        if ( elements.length > 0 ) {
          this.elements = elements;

          if ( typeof elements !== 'undefined' ) {
            this.styleService.httpGetStyles(
              {
                category_id: this.quickDesign.category_id,
                group_id: this.quickDesign.group_id,
                media_attribute_id: this.quickDesign.media_attribute_id,
                department_id: this.quickDesign.department_id
              }
            );

          }
        }
      }
    );

    this.subscriptionStyle = this.styleService.stylesChanged.subscribe(
      (styles: any) => {
        if ( typeof styles !== 'undefined' && styles.status === 'success' ) {
          if ( styles.data.length > 0 ) {
            this.style = styles.data[0];
            this.initStyle();

            this.initEditor();
            this.initBuild();
          }
        }
      }
    );

    this.subscriptionBuild = this.quickDesignService.quickDesignBuild.subscribe(
      (quickDesign: QuickDesign) => {

        if ( typeof quickDesign.ID !== 'undefined' ) {
          this.loading = false;
        }
      }
    );

  }

  initEditor() {
    const $this = this;

    this.editor = grapesjs.init({
      container : '#builder-html',
      height: '100%',
      panels: {
        defaults: []
      },
      deviceManager: {
        devices: [
          {name: 'Desktop', width: '900px' },
          {name: 'Desktop view', width: '901px' },
          {name: 'Mobile portrait', width: '330px'},
          {name: 'A4 portrait', width: '821px'},
          {name: 'A4 landscape', width: '1144px'},
          {name: 'A3 portrait', width: '1104px'},
          {name: 'A3 landscape', width: '97%'},
          {name: 'FB cover', width: '832px'},
          {name: 'FB post', width: '944px'},
          {name: 'DL card', width: '821px'},
          {name: 'Portrait 1200x1800', width: '197mm' },
          {name: 'Portrait 1200x2400', width: '1178px' },
          {name: 'Landscape 1800x1200', width: '1168px' },
          {name: 'Landscape 1750x1130', width: '1168px' }
        ],
      },
      storageManager: {
        type: 'remote',
        autosave: false,
        autoload: false
      },
      autorender: false,
      plugins: this.plugins,
      pluginsOpts: { },
      copyPaste: false,
      avoidInlineStyle: false,
      keepEmptyTextNodes: true,
      forceClass: false,
      showDevices: false
    });

    const comps = this.editor.DomComponents;

    const originalTable = comps.getType('table');
    const originalCell = comps.getType('cell');
    const originalRow = comps.getType('row');
    const originalTBody = comps.getType('tbody');

    const originalImage = comps.getType('image');
    const originalDefault = comps.getType('default');
    const originalText = comps.getType('text');
    const originalTextNode = comps.getType('textnode');

    const originalLink = comps.getType('link');

    comps.addType('comment', {
      model: originalTextNode.model.extend({
        toHTML() {
          return `<!--${this.get('content')}-->`;
        },
      }, {
        isComponent(el) {
          if (el.nodeType === 8) {
            return {
              tagName: 'NULL', // just need this to avoid some parser rule
              type: 'comment',
              content: el.textContent
            };
          }
        },
      }),
      view: originalTextNode.view.extend({
        render: function() {
          this.el = document.createComment(this.model.attributes.content);

          return this;
        }
      })
    });

    comps.addType('table', {
      model: originalTable.model.extend({
        defaults: Object.assign({}, originalTable.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          hoverable: false,
          selectable: false,
          toolbar: null
        })
      }),
      view: originalTable.view
    });

    comps.addType('tbody', {
      model: originalTBody.model.extend({
        defaults: Object.assign({}, originalTBody.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        })
      }),
      view: originalTBody.view
    });

    comps.addType('row', {
      model: originalRow.model.extend({
        defaults: Object.assign({}, originalRow.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        })
      }),
      view: originalRow.view
    });

    comps.addType('cell', {
      model: originalCell.model.extend({
        defaults: Object.assign({}, originalCell.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        })
      }),
      view: originalCell.view
    });

    comps.addType('mdspacer', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          toolbar: null
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-spacer') ) {
            return {type: 'mdspacer'};
          }
        },
      }),
      view: originalDefault.view
    });

    comps.addType('md-removable', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          copyable: false,
          layerable: true
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.hasClass('md-removable') ) {
            return {type: 'md-removable'};
          }
        },
      }),
      view: originalDefault.view
    });

    comps.addType('text', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          hoverable: false,
          editable: true,
          draggable: false,
          droppable: false,
          copyable: false,
          badgable: false
        }),
      }),
      view: originalText.view
    });

    comps.addType('md-library-search', {
      model: originalImage.model.extend({
        defaults: Object.assign({}, originalImage.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          copyable: false,
          badgable: false,
          stylable: true,
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-library-search') ) {
            return {type: 'md-library-search'};
          }
        },
      }),
      view: originalImage.view.extend({
        events: {
          mouseleave: 'handleMouseLeave',
          click: 'handleClick'
        },
        handleMouseLeave: function(e) {
          $this.enable_zoom = false;
          $this.disableZoom();
        },
        handleClick: function(e) {
          $this.enable_zoom = true;
          $this.enableZoom();

          const parentEl = this.model.view.$el.parent();
          const iframeLeft = $('iframe').offset().left;
          const panelWidth = $('.gjs-pn-views-container').width();
          const iframeScrollTop = $('iframe').contents().find('body').scrollTop();
          const parentOffsetTop =  (iframeScrollTop + parentEl.offset().top + 2) + 'px';
          const parentOffsetLeft = ((iframeLeft - panelWidth) + parentEl.offset().left - 8) + 'px';

          $('#tb_overwrite').remove();
          $('head').append(`
            <style id="tb_overwrite">
            .tb_overwrite {
              top:` + parentOffsetTop + ` !important;
              left: ` + parentOffsetLeft + ` !important;
            }
            </style>
          `);
        },
        render: function() {
          originalImage.view.prototype.render.apply(this, arguments);

          const tb = this.model.get('toolbar');
          const isExist = tb.find(
            function (tbi) {
              return tbi.command === 'md-el-image-gallery';
            }
          );

          if (typeof isExist === 'undefined') {
            tb.push({
              attributes: {class: 'fa fa-image', title: 'Image Gallery'},
              command: 'md-el-image-gallery',
            });
          }

          this.model.set('toolbar', tb);

          return this;
        }
      })
    });

    comps.addType('mdbox', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          droppable: false,
          highlightable: false,
          layerable: true
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-box') ) {
            return {type: 'mdbox'};
          }
        },
      }),
      // view: originalDefault.view
      view: originalDefault.view
    });

    comps.addType('custom-link', {
      model: originalLink.model.extend({
        defaults: Object.assign({}, originalLink.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          highlightable: false,
          layerable: true,
          badgable: false,
          selectable: false,
          copyable: false,
          stylable: false,
          hoverable: false,
          editable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.hasClass('md-updatable-anchor') ) {
            // elm.attr('draggable', false);
            return {type: 'custom-link'};
          }
        },
      }),
      // view: originalDefault.view
      view: originalLink.view.extend({
        events: {
          dblclick: 'handleClick'
        },
        handleClick: function(e) {
          const linkElement = $(this.el);
          const dataLink = $(linkElement).data('link');
          let linkTitle = '';

          let anchorText = linkElement.html();
          let anchorLink = linkElement.attr('href');
          let html = '';

          if (linkElement.children().is('img')) {
            html = `
            <input
              id="anchorLink"
              placeholder="Href"
              value="` + $.trim(anchorLink) + `"
              class="form-control mb-1">
            `;
          } else {
            html = `
            <p>Please enter your desired url below.
            Please note this will not update the link in your settings, only the link for this field.</a>
            <br />
            <br />
            Link Name:
             <input
              id="anchorText"
              placeholder="Label"
              value="` + $.trim(anchorText) + `"
              class="form-control mb-1"
              style="border: 1px solid #e8e8e8">
            <br />
            Link:
            <input
             id="anchorLink"
             placeholder="Href"
             value="` + $.trim(anchorLink) + `"
             class="form-control mb-1"
             style="border: 1px solid #e8e8e8">
            `;
          }

          if (dataLink === undefined) {
            linkTitle = 'Link Destination';
          } else {
            linkTitle = dataLink;
          }

          const model = this.model;
          swal({
            title: linkTitle,
            html: html,
            showCancelButton: true,
            confirmButtonText: 'Update',
            showLoaderOnConfirm: true,
            preConfirm: function (data) {
              return new Promise(function (resolve, reject) {
                setTimeout(function() {
                    resolve();
                }, 200);
              });
            },
            allowOutsideClick: false
          }).then(function (data) {

            anchorText = $('#anchorText').val();
            anchorLink = $('#anchorLink').val();

            if (linkElement.children().is('img')) {
              model.setAttributes({'href': anchorLink});
            } else {
              model.set('content', anchorText);
              model.setAttributes({'href': anchorLink});
            }

          }).catch(swal.noop);
        },
        render: function() {
          originalLink.view.prototype.render.apply(this, arguments);

          // Fix dragging issue of anchor tag element
          const model = this.model;
          model.setAttributes(Object.assign({}, model.getAttributes(), {draggable: false}));

          return this;
        }
      })
    });

    comps.addType('span-b-em-u-i-strong', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          editable: false,
          selectable: false,
          badgable: false,
          droppable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.is('span') || elm.is('b') || elm.is('em') || elm.is('u') || elm.is('i') || elm.is('strong') ) {
            return {type: 'span-b-em-u-i-strong'};
          }
        },
      }),
      view: originalText.view.extend({
        events: {
          dblclick: 'handleClick'
        },
        handleClick: function(e) {
          const parentEl = this.model.view.$el.parents('p');

          parentEl.trigger('dblclick');
        }
      })
    });

    // comps.addType('custom-image', {
    //   model: originalDefault.model.extend({
    //     defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
    //       draggable: false
    //     })
    //   })
    // });

    comps.addType('p-editable-w-spans', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          droppable: false,
          badgable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.is('p') && ( elm.has('span') || elm.has('b') || elm.has('em') || elm.has('u') || elm.has('i') || elm.has('strong')) ) {
            return {type: 'p-editable-w-spans'};
          }
        },
      }),
      view: originalText.view
    });

    comps.addType('md-content-editable', {
      model: {
        isComponent(el) {
          const elm = $(el);
          if ( elm.hasClass('md-content-editable') && elm.is('div') ) {
            return {type: 'text'};
          }
        },
      }
    });

    comps.addType('non-droppable-ul', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          droppable: false,
          badgable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);

          if ( elm.is('ul') ) {
            return {type: 'non-droppable-ul'};
          }
        },
      }),
      view: originalDefault.view
    });

    comps.addType('non-droppable-li', {
      model: originalText.model.extend({
        defaults: Object.assign({}, originalText.model.prototype.defaults, {
          droppable: false,
          badgable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);

          if (  elm.is('li') ) {
            return {type: 'non-droppable-li'};
          }
        },
      }),
      view: originalText.view
    });

    comps.addType('a-link', {
      model: originalLink.model.extend({
        defaults: Object.assign({}, originalLink.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          badgable: false,
          copyable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          editable: false
        }),
      }, {
        isComponent(el) {
          const elm = $(el);
          if ( elm.is('a') && (elm.has('img') && !elm.hasClass('md-updatable-anchor')) ) {
            return {type: 'a-link'};
          }
        },
      }),
      view: originalLink.view.extend({
        render: function() {
          originalLink.view.prototype.render.apply(this, arguments);

          // Fix dragging issue of anchor tag element
          const model = this.model;
          model.setAttributes(Object.assign({}, model.getAttributes(), {draggable: false}));

          return this;
        }
      })
    });
    comps.addType('md-uneditable', {
      model: originalDefault.model.extend({
        defaults: Object.assign({}, originalDefault.model.prototype.defaults, {
          draggable: false,
          droppable: false,
          removable: false,
          highlightable: false,
          copyable: false,
          badgable: false,
          stylable: false,
          selectable: false,
          hoverable: false,
          editable: false,
          toolbar: null
        }),
      }, {
        isComponent: function(el) {
          const elm = $(el);
          if ( elm.hasClass('md-uneditable') ) {
            return {type: 'md-uneditable'};
          }
        },
      }),
      view: originalDefault.view
    });

    this.editor.render();


    const iframeBody = this.editor.Canvas.getBody();
    $(iframeBody).on('paste', '[contenteditable="true"]', function(e) {

      const $el = $(this);
      setTimeout(function () {
        let html = $el.html();
        html = $this.stripSmartQuotes(html);
        $el.html(html);
      });

    });

    $('.gjs-cv-canvas').attr('id', 'gjs-ck-editor-test');
  }

  initBuild() {
    const thisRouter = this.router;
    const thisRoute = this.route;
    const $this = this;

    const panelManager = this.editor.Panels;
    const blockManager = this.editor.BlockManager;
    const commands = this.editor.Commands;

    const leftPanel = panelManager.addPanel({
      id: 'left-control',
      buttons: [{
        id: 'back',
        className: 'fa fa-arrow-left',
        command: 'back',
        attributes: {['title']: 'Back'}
      }]
    });

    const rightPanel = panelManager.addPanel({
      id: 'right-control',
      buttons: [
      {
        id: 'undo',
        className: 'fa fa-undo',
        command: 'undo',
        attributes: {['title']: 'Undo'}
      }, {
        id: 'redo',
        className: 'fa fa-repeat',
        command: 'redo',
        attributes: {['title']: 'Redo'}
      },
      {
        id: 'save',
        className: 'btn-html-save',
        command: 'save',
        attributes: {['title']: 'Save'}
      }
      ]
    });

    const controlPanel = panelManager.addPanel({
      id: 'controls',
      buttons: [
      {
        id: 'sw-visibility',
        command: 'sw-visibility',
        className: 'fa fa-square-o',
        attributes: {['title']: 'View Components'},
        active: 1,
      }, {
        id: 'fullscreen',
        command: 'fullscreen',
        className: 'fa fa-arrows-alt',
        attributes: {['title']: 'Fullscreen'},
      }, {
        id: 'clean-all',
        command: 'clean-all',
        className: 'fa fa-trash',
        attributes: {['title']: 'Empty Canvas'},
      }
      ]
    });

    const devicePanel = panelManager.addPanel({
      id: 'devices',
      buttons: [{
        id: 'set-device-desktop',
        command: 'set-device-desktop',
        className: 'fa fa-desktop',
        attributes: {['title']: 'Desktop'},
        active: true,
      }, {
        id: 'set-device-mobile',
        command: 'set-device-mobile',
        className: 'fa fa-mobile',
        attributes: {['title']: 'Mobile'},
      }]
    });

    const viewPanel = panelManager.addPanel({
      id: 'views',
      buttons: [{
        id: 'open-blocks',
        command: 'open-blocks',
        className: 'fa fa-desktop',
        attributes: {['title']: 'Blocks'},
        active: true
      }]
    });

    commands.add('back', {
      run:  function(editor, sender){
        sender.set('active', false);
        thisRouter.navigate(['../../'], {relativeTo: thisRoute});
      }
    });

    commands.add('undo', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.UndoManager.undo(true);
      }
    });
    commands.add('redo', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.UndoManager.redo(true);
      },
    });
    commands.add('set-device-desktop', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.setDevice('Desktop');
      },
    });
    commands.add('set-device-mobile', {
      run:  function(editor, sender){
        sender.set('active', false);
        editor.setDevice('Mobile portrait');
      },
    });
    commands.add('clean-all', {
      run:  function(editor, sender){
        sender.set('active', false);
        if( confirm('Are you sure to clean the canvas?') ) {
          editor.DomComponents.clear();
        }
      },
    });

    commands.add('save', {
      run:  function(editor, sender){
        sender.set('active', false);
        if ( confirm('Are you want to save changes?') ) {
          $this.saveHtml(editor);
        }
      },
    });

    commands.add('pdf', {
      run:  function(editor, sender){
        sender.set('active', false);
        const pdf_url = $this.adminService.appConfig.S3_URL + 'quick-designs/pdfs/' + $this.id + '.pdf';

        let link = document.createElement('a');
        link.download = 'a';
        link.href = pdf_url;
        document.body.appendChild(link);
        link.click();
        link.remove();
      },
    });

    commands.add('md-el-image-gallery', {
      run: function(editor){
        const model = editor.getSelected();
        const mdPropBox = model.view.$el.parents('.md-prop-box');

        $this.subLoading = true;
        $this.selectedFileHolder = model.view.el;
        $this.selectedFile = [];

        $($this.mdLibrarySearchModal.nativeElement).modal('show');
      }
    });

    const openBlocksBtn = this.editor.Panels.getButton('views', 'open-blocks');

    // tslint:disable-next-line:no-unused-expression
    openBlocksBtn && openBlocksBtn.set('active', 1);

    for (const element of this.elements) {
      const elementHtml = element.html;
      // if (element.thumbnail !== '') {
      //   elementHtml = '<div class="block-temp-holder"><img src="' + element.thumbnail + '"><div>' + element.html + '</div></div>';
      // }
      blockManager.add(element.title, {
        category: element.block.title,
        label: element.title,
        content: elementHtml,
        icon: element.icon
      });
    }

    const parseContent = jQuery('<div>' + this.quickDesign.html + '</div>');

    $('.gjs-blocks-cs').css('margin-top', '-80px');
    $('.btn-html-save').html('<span class="fa fa-floppy-o"></span> Save');

    parseContent.find('.md-box').attr('data-gjs-type', 'mdbox');

    this.editor.setComponents(parseContent.html());
    this.editor.setStyle(this.quickDesign.html_data['style']);

    // this.editor.setComponents(this.quickDesign.html);
  }

  initStyle() {
    const iframe = $(this.builder.nativeElement).find('iframe').contents();
    const htmlStyle = this.style.style;
    // iframe.find('.md-content-editable').attr('data-gjs-type', 'text');

    iframe.find('.gjs-css-rules').remove();

    const external_font_list = (this.style.external_font).split('\n');
    for (const external_font of external_font_list) {
      if (external_font) {
        const externalFont = $('<link>').attr('rel', 'stylesheet')
          .attr('href', external_font);

        iframe.find('head').append(externalFont);
      }
    }

    const external_css_list = (this.style.external_css).split('\n');
    for (const external_css of external_css_list) {
      if (external_css) {
        const externalLink = $('<link>').attr('rel', 'stylesheet')
          .attr('type', 'text/css')
          .attr('href', external_css);

        iframe.find('head').append(externalLink);
      }
    }

    iframe.find('head').append(
      $('<style>').text(htmlStyle)
    );

    iframe.find('head').append(
      $('<style>').text(`
      .page-divider {
        border-bottom: 2px dashed #8da3b0;
        display: block;
        padding: 20px 0 0;
        margin: 0 0 20px 0;
      }
      .page {
        margin:0 auto 40px auto;
        box-shadow: 0 0 40px rgba(0,0,0,0.3);
      }
      .md-hidden {
        display: none;
      }
      .md-prop-search.ui-draggable, .md-library-search.ui-draggable  {
        cursor: pointer;
      }
      `)
    );

    const external_js_list = (this.style.external_js).split('\n');

    for (const external_js of external_js_list) {
      if (external_js) {
        const externalLink = $('<script>').attr('type', 'text/javascript')
          .attr('src', external_js);

        iframe.find('head').append(externalLink);
      }
    }

    iframe.find('body').append($('<div>').attr('id', 'after-body-script').html(''));

    this.initScript();
  }

  initScript() {
    const iframe = $(this.builder.nativeElement).find('iframe').contents();
    const afterBody = iframe.find('#after-body-script').html('');

    afterBody.append(
      $('<script type="text/javascript">').text(
        `` + this.style.script + ``
      )
    );


    this.loading = false;
  }


  saveHtml(editor: any, pdf: boolean = false) {
    this.loading = true;
    const html = editor.getHtml();
    const html_data_style = editor.getStyle();
    const html_data_css = editor.getCss();

    const html_raw = juice(html + '<style>' + html_data_css + '</style>', {preserveMediaQueries: false});

    let quickDesignValues: Object = {};

    quickDesignValues['html'] = html_raw;
    quickDesignValues['html_data'] = { style: html_data_style , css: html_data_css};

    this.quickDesignService.httpBuildQuickDesign(this.id, <QuickDesign>quickDesignValues);
  }

  enableZoom() {
      const elemMd = $('.gjs-cv-canvas')
        .find('iframe')
        .contents()
        .find('.md-prop-search, .md-library-search');

      if ( elemMd.length ) {
        const $this = this;

        elemMd
        .draggable({
          start: function() {
            const elImg = $this.editor.getSelected();

            if ( elImg.view.$el.attr('id') !== $(this).prop('id') ) {
              return false;
            }

            if ( elImg.view.$el.is('.md-library-search, .md-prop-search') === false ) {
              return false;
            }
          },
          stop: function() {
            const elImg = $this.editor.getSelected();
            const elImgStyle = elImg.getStyle();

            const dragTop = $(this).css('top');
            const dragLeft = $(this).css('left');

            elImgStyle.position = 'absolute';
            elImgStyle.top = dragTop;
            elImgStyle.left = dragLeft;

            elImg.set('style', elImgStyle);

            setTimeout(() => {
              $(elImg.view.$el).trigger('click');
            }, 10);
          }
        })
        .parent()
        .css({overflow: 'hidden'})
        .find('img')
        .unbind('wheel mousewheel DOMMouseScroll')
        .bind('wheel mousewheel DOMMouseScroll', function(e){
          const elImg = $this.editor.getSelected();
          const elImgStyle = elImg.getStyle();

          if (e.type === 'DOMMouseScroll' || e.type === 'wheel') {
            e.preventDefault();

            return;
          }

          let delta;

          if (e.originalEvent.wheelDelta !== undefined) {
              delta = e.originalEvent.wheelDelta;
          } else {
              delta = e.originalEvent.deltaY * -1;
          }

          let sizeWidth = $(this).width();
          let sizeHeight = $(this).height();

          if (delta > 0) {
            sizeWidth += 5;
            sizeHeight += 5;
          } else {
            sizeWidth -= 5;
            sizeHeight -= 5;
          }
          sizeWidth += 'px';
          sizeHeight += 'px';

          $(this).width(sizeWidth);
          $(this).height(sizeHeight);

          elImgStyle.width = sizeWidth;
          elImgStyle.height = sizeHeight;

          elImg.set('style', elImgStyle);
        });
      }
  }

  disableZoom() {
    const elemMd = $('.gjs-cv-canvas')
        .find('iframe')
        .contents()
        .find('.md-prop-search, .md-library-search');

        elemMd
        .unbind('wheel mousewheel DOMMouseScroll');
  }

  stripSmartQuotes(string) {
    return String(string)
            .replace(/[“]/g, '"')
            .replace(/[”]/g, '"')
            .replace(/[‘]/g, '&#39;')
            .replace(/[’]/g, '&#39;');
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionElement.unsubscribe();
    this.subscriptionStyle.unsubscribe();
    this.subscriptionBuild.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/templates/quick-designs/quick-design-build/quick-design-build.component.ts